import { CustomAlertComponent } from "./custom-alert/custom-alert.component";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { CommonModule } from "@angular/common";
import { NotificationsButtonComponent } from "./notifications/notifications-button/notifications-button.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UploadModalComponent } from "./upload-modal/upload-modal.component";
import { KpiAnalyticsComponent } from "./kpi-analytics/kpi-analytics.component";
import { AddOtComponent } from "./add-ot/add-ot.component";

@NgModule({
  declarations: [
    CustomAlertComponent,
    NotificationsButtonComponent,
    UploadModalComponent,
    KpiAnalyticsComponent,
    AddOtComponent,
  ],

  imports: [IonicModule.forRoot(), CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    CustomAlertComponent,
    NotificationsButtonComponent,
    UploadModalComponent,
    KpiAnalyticsComponent,
    AddOtComponent,
  ],
  entryComponents: [UploadModalComponent, AddOtComponent],
})
export class ComponentsModule { }
